import { defineComponent as t, openBlock as o, createElementBlock as s, createElementVNode as r } from "vue";
import { _ as n } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/StaticSpinner.css';const c = {
  viewBox: "0 0 128 128",
  class: "icon-spin uikit-h-6 uikit-w-6"
}, i = ["stroke", "stroke-width"], a = /* @__PURE__ */ t({
  __name: "StaticSpinner",
  props: {
    thickness: { default: 9 },
    strokeColor: { default: "#fff" }
  },
  setup(l) {
    return (e, p) => (o(), s("svg", c, [
      r("circle", {
        class: "path",
        cx: "64",
        cy: "64",
        r: "42",
        fill: "none",
        stroke: e.strokeColor,
        "stroke-width": e.thickness
      }, null, 8, i)
    ]));
  }
}), k = /* @__PURE__ */ n(a, [["__scopeId", "data-v-ff694776"]]);
export {
  k as default
};
